import React from "react";
import { BoxIcon } from "lucide-react";
type KpiCardProps = {
  label: string;
  value: string;
  icon: BoxIcon;
  tone?: "green" | "amber" | "red";
  onClick?: () => void;
};
const colors = {
  green: "bg-[#e5f4e8] text-[#176B3A]",
  amber: "bg-[#fff3dc] text-[#a76600]",
  red: "bg-[#fde8e8] text-[#b42323]"
};
export function KpiCard({
  label,
  value,
  icon: Icon,
  tone = "green",
  onClick
}: KpiCardProps) {
  const content = <><div className={`flex h-8 w-8 items-center justify-center rounded-lg ${colors[tone]}`} data-id="element-125" data-mp="2opbdqs8esqyg"><Icon size={17} data-id="element-126" data-mp="2jnvun5pskuip" /></div><p className="mt-2 text-[11px] leading-tight text-[#66756B]" data-id="element-127" data-mp="2jncbjloeo033">{label}</p><p className="mt-1 text-xl font-bold text-[#1D2A22]" data-id="element-128" data-mp="2eqlyz8bt7mmf">{value}</p></>;
  return onClick ? <button onClick={onClick} className="rounded-xl bg-white p-3 text-left shadow-[0_2px_10px_rgba(15,81,50,.06)] ring-1 ring-[#e1ece4] transition active:scale-[.98]" data-id="element-129" data-mp="2aoqyg61pdd9p">{content}</button> : <article className="rounded-xl bg-white p-3 shadow-[0_2px_10px_rgba(15,81,50,.06)] ring-1 ring-[#e1ece4]" data-id="element-130" data-mp="8w2pdg2dnvm0">{content}</article>;
}